// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2lYSw","info":"PatientInfo_info__eTBmn"};